import React, { useState } from 'react'
import { Alert } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

export const ForceTakeAwayAlert = () => {
  const [isTakeAwayAlertVisible, setIsTakeAwayAlertVisible] = useState(true)

  if (!isTakeAwayAlertVisible) {
    return null
  }

  return (
    <Alert variant="warning" onDismiss={() => setIsTakeAwayAlertVisible(false)}>
      <FormattedMessage id="checkout.change-shipping-method-drawer-take-away-alert" />
    </Alert>
  )
}
